<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_SERVICES.EDIT_RESELLER_SERVICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <reseller-service-form
              :loading="loading"
              :resellerServiceData="resellerService"
              :formErrors="formErrors"
              @resellerServiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ResellerServiceForm from "./partials/ResellerServiceForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerService from "./defaultResellerService";

export default {
  layout: "DashboardLayout",

  components: { ResellerServiceForm },

  mixins: [alertLeave],

  data() {
    return {
      resellerService: cloneDeep(defaultResellerService),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("resellerServices/get", id);
        this.resellerService =
          this.$store.getters["resellerServices/resellerService"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List ResellerServices" });
    },

    viewResellerService() {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerService",
        params: { id: this.resellerService.id },
      });
    },

    async handleSubmit(resellerService) {
      this.loading = true;
      const resellerServiceData = cloneDeep(resellerService);

      try {
        await this.$store.dispatch(
          "resellerServices/update",
          resellerServiceData
        );
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_SERVICES.RESELLER_SERVICE_UPDATED"),
        });
        this.viewResellerService();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
